import { register } from "@rill/loader";

register(
  {
    name: "listNews",
  },
  async ({ api }, { skip = 0, limit = 10 } = {}) => {
    const res = await api("news", {
      query: { skip, limit, sort: { createdAt: -1 } },
    });
    return res.json();
  }
);

register(
  {
    name: "unreadNewsCount",
    meta: ["no-bust", "news"],
    ttl: "30 minutes",
  },
  async ({ api }) => {
    const res = await api("news-count");
    const data = await res.json();
    return data.count || 0;
  }
);

register(
  {
    name: "adminNews",
  },
  async ({ api }, { skip = 0, limit = 50, filterFrom, filterTo, filterPublished } = {}) => {
    const query = { skip, limit, admin: true, sort: { createdAt: -1 } };
    if (filterFrom) query.from = filterFrom;
    if (filterTo) query.to = filterTo;
    if (filterPublished === "1") query.published = "true";
    else if (filterPublished === "0") query.published = "false";
    const res = await api("news", { query });
    const result = await res.json();
    return result;
  }
);
